<template>
    <div class="inner_top">
      <div
        class="hover-font-active"
        :class="{ 'item-active': tabIndex == '1' }"
        @click="goDetail('teacherAttend')"
      >
        考勤汇总
      </div>
      <div
        class="hover-font-active"
        :class="{ 'item-active': tabIndex == '2' }"
        @click="goDetail('workDetail')"
      >
        考勤明细
      </div>
    </div>
  </template>
  
  <script>
  export default {
    props: ['tabIndex'],
    data() {
      return {}
    },
    methods: {
      goDetail(name) {
        this.$router.push(name)
      },
    },
  }
  </script>
  
  <style lang="less" scoped>
  .inner_top {
    border-bottom: 1px solid rgba(0, 0, 0, 0.09);
    line-height: 40px;
    margin-bottom: 20px;
    div {
      font-size: 14px;
      color: #909399;
      display: inline-block;
      width: 90px;
      text-align: center;
      border-bottom: 2px solid white;
    }
    .item-active {
      color: #1890ff;
      border-bottom: 2px solid #1890ff;
    }
  }
  </style>
  